<template>
  <div>
    <h3 class="header-title">Learning</h3>
    <label>Let’s see your tuition package.</label>
    <br />
    <label
      >
      You have subscribed to the {{ user.packageName }} package, which is valid until  {{ user.validTo }}. This subscription comes at a price of {{ user.currencyCode}}  {{ user.invoiceprice }} and 
      includes a limit of {{ check.NumberOfStudent }} students and <span v-if="check.TotalTeacher === 0">Unlimited</span><span v-else>{{ check.TotalTeacher }} </span> teachers.
      
      </label
    >
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Explore more on your package!</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <div v-if="user.validTo < currentDate" class="mt-2">
      <CAlert show color="danger">
        <CRow>
          <CCol sm="10">
            <strong class="text-danger mr-2"
          >X ERROR ! Your subscription package has expired. Please renew your
          current subscription or upgrade to a new package.
        </strong>
          </CCol>
          <CCol sm="2" class="text-right">
            <CButton type="button" class="custom-btn-navy" @click="GoToRenew()">Renew</CButton>
          </CCol>

        </CRow>
       
      </CAlert>
    </div>
    <div v-if="Busy == true">
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </div>
    <div v-else>
      <CCol sm="12" class="mt-4">
        <CRow>
          <CCol sm="8">
            <CRow>
              <CCol sm="4">
                <CInput
                  type="text"
                  placeholder="Search..."
                  v-model.lazy="SearchQuery"
                  @change="ApplyFilter()"
                />
              </CCol>
              <CCol sm="6">
                <!-- <CInput
            type="text"
            placeholder="Search Subject"
            v-model="SearchQueryPackage"
          /> -->
              </CCol>
            </CRow>
          </CCol>
          <CCol sm="4">
            <div style="float: right">
              <CButton
                class="btn custom-btn-lgt"
                type="button"
                @click="OpenFormPackage()"
                ><CIcon name="cil-plus" />Add Package</CButton
              >
            </div>
          </CCol>
          <CCol sm="6"> </CCol>
        </CRow>
      </CCol>
      <CCol sm="12">
        <CDataTable
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          :items="user.validTo < currentDate ? FilteredPackagesList.slice(0, 5) : FilteredPackagesList"
          :fields="fields"
          items-per-page-select
          :items-per-page="small ? 5 : 10"
          clickable-rows
          sorter
          pagination
        >
          <template #PackageName="{ item }">
            <td>
              <h6 style="color: #1e109c" class="text-uppercase">
                {{ item.Name }}
              </h6>
              <div class="small text-muted">Desc : {{ item.Description }}</div>
            </td>
          </template>

          <template #Subject="{ item }">
            <td>
              <tr v-for="su in item.Subject" v-bind:key="su.Id">
                <li>{{ su.Name }} ( {{ su.Rate }} )</li>
              </tr>
            </td>
          </template>

          <template #TotalStudent="{ item }">
            <td>
              {{ item.TotalStudent }}
            </td>
          </template>

          <template #Action="{ item }">
            <td>
              <CDropdown
                toggler-text="Action"
                class="m-2 btn-act"
                color="primary"
              >
                <CDropdownItem @click="OpenAssignSubject(item)"
                  >Assign Subject</CDropdownItem
                >
                <hr />
                <CDropdownItem @click="OpenUpdate(item)">Edit</CDropdownItem>
                <CDropdownItem @click="OpenDeletePackage(item)"
                  >Delete</CDropdownItem
                >
              </CDropdown>
            </td>
          </template>
        </CDataTable>
      </CCol>

      <CModal
        title="Add New Package"
        size="md"
        :show.sync="PackageModal"
        :close-on-backdrop="false"
        :close-on-esc="false"
      >
        <div>
          <h6><strong>FORM PACKAGE</strong></h6>
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="3"> Name </CCol>
              <CCol sm="9">
                <CInput type="text" v-model="Name" />
              </CCol>
              <CCol sm="3"> Description </CCol>
              <CCol sm="9">
                <CInput type="text" v-model="Description" />
              </CCol>
            </CRow>
          </CCol>
        </div>
        <template #footer>
          <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="SubmitPackage()"
            >{{ lblNewPackage }}</CButton
          ></template
        >
      </CModal>

      <CModal
        title="Edit Package"
        size="md"
        :show.sync="EditPackageModal"
        :close-on-backdrop="false"
        :close-on-esc="false"
      >
        <div>
          <h6><strong>DETAIL PACKAGE</strong></h6>
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="5">Package name</CCol>
              <CCol sm="7">
                <CInput type="text" v-model="PackageName" />
              </CCol>
              <CCol sm="5">Description </CCol>
              <CCol sm="7">
                <CInput type="text" v-model="PackageDescription" />
              </CCol>
            </CRow>
          </CCol>
        </div>
        <template #footer>
          <CCol sm="12">
            <CRow>
              <CCol sm="9">
                <input type="checkbox" v-model="autoRefresh" class="mr-3" />Auto
                Refresh
              </CCol>
              <CCol sm="3">
                <CButton
                  type="submit"
                  class="p-2"
                  color="info"
                  @click="UpdatePackage(PackageId)"
                  >{{ lblUpdatePackage }}</CButton
                >
              </CCol>
            </CRow>
          </CCol>
        </template>
      </CModal>

      <CModal
        title="Assign Subject"
        size="md"
        :show.sync="AssignSubjectModal"
        :close-on-backdrop="false"
        :close-on-esc="false"
      >
        <div>
          <h6><strong>DETAIL PACKAGE</strong></h6>
          <br />

          <CCol sm="12">
            <CRow>
              <CCol sm="12">
                Subject Info : {{ packagesDetail.Name }}
                <br />
                Description : {{ packagesDetail.Description }}
                <br />
                Learning Center: {{ packagesDetail.LearningCenter }}
                <br />
                Fee:
                <br />
              </CCol>
            </CRow>
          </CCol>
          <br />
          <h6><strong>ADD ASSIGN SUBJECT</strong></h6>
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="4"> Subject</CCol>
              <CCol sm="8">
                <v-select
                  v-model="selectedSubject"
                  :options="subjects"
                  label="Name"
                  placeholder="--Please Select Subject--"
                ></v-select>
                <CButton
            type="submit"
            class="p-2 mt-2 float-right"
            color="info"
            @click="CreateAssignSubject(packagesDetail.PackageId)"
            >{{ lblAssignSubject }}</CButton
          >
              </CCol>
            </CRow>
          </CCol>
          <br />
          <h6><strong>REMOVE SUBJECT</strong></h6>
          <br />
          <div style="clear: both"></div>
          <CCol sm="12">
            <CDataTable
              :small="small"
              :fixed="fixed"
              :items="FilteredSubjectList"
              :fields="fieldSubjects"
              items-per-page-select
              :items-per-page="small ? 5 : 5"
              clickable-rows
              pagination
              table-filter
            >
              <template #Name="{ item }">
                <td>
                  {{ item.Name }}
                </td>
              </template>
              <template #Action="{ item }">
                <td>
                  <CButton
                    type="button"
                    class="btn btn-danger"
                    @click="OpenDeleteSubjects(item)"
                  >
                    <CIcon name="cil-trash"
                  /></CButton>
                </td>
              </template>
            </CDataTable>
          </CCol>
        </div>
        <template #footer>
    <div style="border-top: none;border:1px solid transparent">
      <!-- Add your custom HTML elements for the footer here -->
      <CButton style="display:none">OK</CButton> 
      <CButton style="display:none">Cancel</CButton> 
    </div>
  </template>
      </CModal>
    </div>
  </div>
</template>


<script>
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(VuejsDialog);
export default {
  name: "Tables",
  components: {
    PulseLoader,
  },
  data() {
    return {
      packages: [],
      SearchQuery: "",
      FilteredPackages: [],

      perPage: 10,
      pagination: {},
      currentPage: 1,
      Busy: false,

      small: "",
      fixed: "",
      bordered: "",
      size: "",

      fields: [
        { key: "PackageName" },
        { key: "Subject" },
        { key: "TotalStudent" },
        { key: "Action" },
      ],

      Name: "",
      Description: "",
      PackageModal: false,

      EditPackageModal: false,
      PackageName: "",
      PackageDescription: "",

      packagesDetail: {},

      subjects: [],
      subjectsList: [],
      FilteredSubjectList: [],

      fieldSubjects: [{ key: "Name" }, { key: "Action" }],
      selectedSubject: "",

      AssignSubjectModal: false,
      SearchQueryPackage: "",

      lblNewPackage: "Proceed",

      autoRefresh: false,

      lblUpdatePackage: "Proceed",
      lblAssignSubject: "Assign Subject",
      user: {},
      currentDate: new Date().toISOString().substring(0, 10),
      check: {},

    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetPackage();
    } else {
      this.GoToLogin();
    }
  },
  computed: {
    FilteredPackagesList() {
      if (this.SearchQuery === "") return this.FilteredPackages;
      return this.FilteredPackages.filter((item) => {
        //teacher name
        for (const { Name } of item.Subject) {
          if (Name.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1) {
            return item;
          }
        }

        if (
          item.Name.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1
        ) {
          return item;
        }
      });
    },
  },
  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetCheckTc(this.user.tuitioncenter);
          }
        });
    },
    GetCheckTc(tuitioncenter) {
      return this.$API
        .get(this.$GetCheckTcPackage + "?TuitionCenterId=" + tuitioncenter, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.check = response.data;
          }
        });
    },
    RefreshData() {
      this.GetPackage();
    },
    GetPackage() {
      this.Busy = true;
      this.$API
        .get(this.$ViewPackage, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.packages = response.data;
            this.FilteredPackages = this.packages;
          }
        });
    },
    // ApplyFilter: function () {
    //   var arr = _.orderBy(this.packages, ["Name"], ["asc"]);
    //   if (_.isEmpty(arr) == false) {
    //     const result = _.filter(arr, ({ Name }) =>
    //       _.some([
    //         _.includes(!Name || Name.toLowerCase(), [
    //           this.SearchQuery.toLowerCase(),
    //         ]),
    //       ])
    //     );
    //     this.FilteredPackages = result;
    //   }
    // },

    OpenFormPackage() {
      this.PackageModal = true;
    },
    async SubmitPackage() {
      this.lblNewPackage = "Processing";
      this.Busy = true;
      const formData = new FormData();

      formData.append("Name", this.Name);
      formData.append("Description", this.Description);

      return this.$API
        .post(this.$InsertPackage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            setTimeout(() => {
              this.PackageModal = false; // set the SubjectModal value to false to close the modal
            }, 5000);
            this.lblNewPackage = "Proceed";
            this.$dialog.alert("Success to saved").then(function () {});
            this.RefreshData();
          } else {
            this.Busy = false;
            this.$dialog
              .alert("Error to create packagess")
              .then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    OpenUpdate(item) {
      this.EditPackageModal = true;
      this.packageId = item.Id;

      this.$API
        .get(this.$GetPackageById + "?id=" + this.packageId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.PackageName = this.info.Name;
            this.PackageDescription = this.info.Description;
          }
        });

      this.EditPackageModal = true;
    },
    UpdatePackage: function () {
      if (this.autoRefresh) {
        this.lblUpdatePackage = "Processing";

        const formData = new FormData();
        formData.append("Id", this.packageId);
        formData.append("Name", this.PackageName);
        formData.append("Description", this.PackageDescription);

        return this.$API
          .post(this.$UpdateTuitionPackage, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.lblUpdatePackage = "Proceed";
              this.$dialog.alert("Success saved").then(function () {});
              this.EditPackageModal = false;
              setTimeout(() => {
                this.UpdatePackage(packageId);
              }, 5000); // refresh every 5 seconds (adjust as needed)

              this.RefreshData();
            } else {
              this.Busy = false;
              this.$dialog
                .alert("Error to update package ")
                .then(function () {});
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      } else {
        this.lblUpdatePackage = "Processing";
        const formData = new FormData();
        formData.append("Id", this.packageId);
        formData.append("Name", this.PackageName);
        formData.append("Description", this.PackageDescription);

        return this.$API
          .post(this.$UpdateTuitionPackage, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.lblUpdatePackage = "Proceed";
              this.$dialog.alert("Success saved").then(function () {});
              this.EditPackageModal = false;
            } else {
              this.Busy = false;
              this.$dialog
                .alert("Error to update package ")
                .then(function () {});
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },
    OpenDeletePackage(item) {
      const formData = new FormData();

      formData.append("Id", item.Id);

      return this.$API
        .post(this.$DeleteTuitionPackage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.$dialog.alert("Details Package Deleted!");
            this.RefreshData();
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    OpenAssignSubject(item) {
      this.packageId = item.Id;

      this.$API
        .get(this.$GetPackageById + "?id=" + this.packageId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.packagesDetail = response.data;
          }
        });
      this.$API
        .get(this.$GetListSubjectTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
          }
        });
      this.$API
        .get(this.$GetListSubjectPackageTc + "?id=" + this.packageId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjectsList = response.data;
            this.FilteredSubjectList = this.subjectsList;
          }
        });
      this.AssignSubjectModal = true;
    },
    async CreateAssignSubject(PackageId) {
      this.lblAssignSubject = "Processing";
      this.TuitionPackageId = PackageId;

      const formData = new FormData();

      formData.append("TuitionSubjectId", this.selectedSubject.SubjectId);
      formData.append("TuitionPackageId", this.TuitionPackageId);

      return this.$API
        .post(this.$InsertAssignSubject, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.lblAssignSubject = "Assign Subject";
            this.$dialog.alert("Success Save").then(function () {});
            this.$API
        .get(this.$GetListSubjectPackageTc + "?id=" + this.TuitionPackageId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjectsList = response.data;
            this.FilteredSubjectList = this.subjectsList;
          }
        });
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    OpenDeleteSubjects(item) {
      const formData = new FormData();

      formData.append("Id", item.SubjectId);

      return this.$API
        .post(this.$DeleteSubjectTuitionPackage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.$dialog.alert("Details Subject Deleted!");
            this.RefreshData();
            this.AssignSubjectModal = false;
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    GoToRenew()
    {
      // window.open("https://www.pickiddo.com/RenewPackage?UserGroupId=" + this.user.usergroupId, "_blank");
      this.$router.push(
        "/Billing"
      );
    }
  },
};
</script>
<style>
.btn-act {
  display: inline-block;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #7460ee;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.custom-btn-lgt {
  background: #7460ee;
  border: 1px solid #7460ee;
  color: #ffffff;
  width: 230px;
}
.btn-primary {
  color: #fff;
  background-color: #7460ee;
  border-color: #7460ee;
}
.btn-primary:hover {
  color: #fff;
  background-color: #7460ee;
  border-color: #7460ee;
}
</style>
